// 获取cookie、
function getCookie (cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') c = c.substring(1)
    if (c.indexOf(name) != -1) return unescape(c.substring(name.length, c.length))
  }
  return ''
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expiredays) {
    let exdate = new Date()
    exdate.setDate(exdate.getDate() + expiredays)
        // 线下
     //let cookiestr = cName + '=' + escape(value) + (((expiredays == null) ? '' : ';expires=' + exdate.toGMTString()))
        // 线上
      let cookiestr = cName + '=' + escape(value) + (((expiredays == null) ? '' : ';expires=' + exdate.toGMTString()) + ';domain=cutmall.cn;path=/')
    document.cookie = cookiestr
        // 线上
       document.domain = 'cutmall.cn';
}
// 删除cookie
function delCookie (name) {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
  }
}

function clearCookie () { // 清空cookie
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
  }
}

// HTMLEncode
function HTMLEncode (html) {
  var temp = document.createElement('div');
  (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html)
  var output = temp.innerHTML
  temp = null
  return output
}

// HTMLDecode
function HTMLDecode (text) {
  var temp = document.createElement('div')
  temp.innerHTML = text
  var output = temp.innerText || temp.textContent
  temp = null
  return output
}

export {
  getCookie,
  setCookie,
  delCookie,
  clearCookie,
  HTMLEncode,
  HTMLDecode
}



// WEBPACK FOOTER //
// ./src/util/util.js